import { useAuthenticatedQuery } from '../useAuthenticatedQuery';
import axios from 'axios';
import { API_BASE_URL, FUNCTION_KEY, PROJECT_SCOPE } from '../../config';
import { convertDateToLocal } from '../metadata/DataUtils';
import logError from '../metadata/ErrorLogging';
import PropTypes from 'prop-types';

/** @typedef {import("@components/cards/events/events.types").TestEvent} TestEvent */

/**
 * Fetches a specific event by its ID.
 * @function useEvent
 * @param {number} event_id - The ID of the event to fetch.
 * @returns {{
*   event: TestEvent | {},
*   isLoading: boolean,
*   refetch: () => Promise<any>,
*   error: any
* }}
*/
export default function useEvent(event_id = null) {

  const fetchEvents = async (token) => {

    const theParams = {
        event_id: event_id
    };
    
    try {
        const response = await axios.get(`${API_BASE_URL}event_details`, {
            headers: {
            'Authorization': `Bearer ${token}`,
            'x-functions-key': FUNCTION_KEY
            },
            params: theParams
        });

        // Convert the dates from UTC to user's local format
        if (response.data.start_time) {
            response.data.start_time = convertDateToLocal(response.data.start_time, false, true);
            response.data.formatted_start_time = convertDateToLocal(response.data.start_time, true, true);
        }

        if (response.data.end_time) {
            response.data.end_time = convertDateToLocal(response.data.end_time, false, true);
            response.data.formatted_end_time = convertDateToLocal(response.data.end_time, true, true);
        }

        return response.data;
    } catch (error) {
      logError('Failed to load event in useEvent', error, theParams); // Error during fetch
      throw error;
    }
  };

  const projectScope = [PROJECT_SCOPE];
  const queryKey = ['event', event_id];

  const { data: event = {}, isLoading, refetch, error } = useAuthenticatedQuery(queryKey, fetchEvents, projectScope, {
    enabled: !!event_id,
    staleTime: 1 * 60 * 1000,  // Data will be cached for 1 minute
  });

  return { event, isLoading, refetch, error };
}

useEvent.propTypes = {
  event_id: PropTypes.number.isRequired
};